import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';

import { type DittoTheme, parseDittoTheme } from '@/lib/dittoTheme';

/**
 * Fetch the active Ditto profile theme (kind 16767) for a given pubkey.
 * Returns a parsed DittoTheme or undefined if the user has no theme set.
 */
export function useDittoTheme(pubkey: string | undefined) {
  const { nostr } = useNostr();

  return useQuery<DittoTheme | undefined>({
    queryKey: ['nostr', 'ditto-theme', pubkey ?? ''],
    queryFn: async () => {
      if (!pubkey) return undefined;

      const events = await nostr.query(
        [{ kinds: [16767], authors: [pubkey], limit: 1 }],
        { signal: AbortSignal.timeout(3000) },
      );

      if (events.length === 0) return undefined;

      return parseDittoTheme(events[0]);
    },
    enabled: !!pubkey,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}
